/**
 * Generador de carga para medir, equivalente al viejo botón "stress" que el
 * README documentaba. Sólo se usa desde el HUD de desarrollo.
 *
 * Arma una malla: cada tarjeta se conecta con la de su derecha y con la de
 * abajo. Con la grilla por defecto son 500 nodos y ~955 aristas, que es el
 * presupuesto declarado en el plan.
 */

import { type StoreApi } from "zustand/vanilla";
import { type DocState } from "../model/store.ts";
import {
  type Card,
  type Edge,
  createId,
  TEXT_BG_NONE,
  TEXT_COLOR_DEFAULT,
} from "../model/types.ts";

const CARD_W = 220;
const CARD_H = 130;
const GAP_X = 160;
const GAP_Y = 120;

export function buildStressDiagram(
  store: StoreApi<DocState>,
  cols = 25,
  rows = 20,
): { cards: number; edges: number } {
  const now = Date.now();
  const cards: Card[] = [];
  const ids: string[][] = [];

  for (let r = 0; r < rows; r++) {
    ids[r] = [];
    for (let c = 0; c < cols; c++) {
      const id = createId();
      ids[r][c] = id;
      cards.push({
        id,
        type: "text",
        x: c * (CARD_W + GAP_X),
        y: r * (CARD_H + GAP_Y),
        width: CARD_W,
        height: CARD_H,
        markdown: "",
        text: {
          text: `${r}·${c}\nnodo de prueba`,
          align: "left" as const,
          background: TEXT_BG_NONE,
          color: TEXT_COLOR_DEFAULT,
          autoWidth: false,
        },
        updatedAt: now,
      });
    }
  }

  const edges: Edge[] = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      if (c + 1 < cols) {
        edges.push({ id: createId("edge"), fromNode: ids[r][c], toNode: ids[r][c + 1], updatedAt: now });
      }
      if (r + 1 < rows) {
        edges.push({ id: createId("edge"), fromNode: ids[r][c], toNode: ids[r + 1][c], updatedAt: now });
      }
    }
  }

  // Un solo paso de deshacer para toda la malla.
  store.getState().transaction(() => {
    store.getState().addCards(cards);
    store.getState().addEdges(edges);
  });

  return { cards: cards.length, edges: edges.length };
}
